var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"site-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',{staticClass:"siteTitle"},[_vm._v("ホテル・リゾート法人優待")]),_c('div',{staticClass:"guarantee"},[_vm._v("法人優待 ベストプライス保証")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }